import React from "react";
import {
  Container,
  Typography,
  Box,
  Paper,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import Footer from './Footer';
import Navbar from "./Navbar";

const RefundPolicy = () => {
  return (
    <div>
      <section><Navbar /></section>

      <section className="top-section">
        <Box
          sx={{
            background: '#8a88bc',
            color: "white",
            textAlign: "center",
            py: { xs: 6, md: 10 },
          }}
        >

          <Typography variant="h3" fontWeight="bold" gutterBottom>
          Refund Policy   
          </Typography>

          <Typography variant="h6" maxWidth="700px" mx="auto">
            Empowering students with skills and knowledge for a brighter future.
          </Typography>
        </Box>
      </section>

      <Container maxWidth="md" sx={{ py: 6 }}>
        <Paper
          elevation={4}
          sx={{ p: { xs: 3, md: 6 }, borderRadius: 3, backgroundColor: "#fafafa" }}
        >
          {/* Title */}
          <Typography
            variant="h3"
            component="h1"
            gutterBottom
            sx={{ fontWeight: "bold", color: "primary.main" }}
          >
            Refund Policy
          </Typography>

          {/* Last Updated */}
          <Typography
            variant="subtitle2"
            gutterBottom
            sx={{ mb: 3, fontStyle: "italic", color: "text.secondary" }}
          >
            Last Updated: September 26, 2025
          </Typography>

          {/* Intro */}
          <Typography variant="body1" paragraph>
            At <strong>Medby Academy</strong> ("we," "us," or "our"), we strive to
            provide high-quality educational content through our online medical
            courses, fellowships, certificate programs, and postgraduate diplomas
            offered on <strong>www.medbyacademy.com</strong> (the "Website" or
            "Services"). This Refund Policy outlines the conditions under which
            refunds may be requested for our Services. By enrolling in any course
            or program, you agree to the terms of this Refund Policy.
          </Typography>

          {/* Section 1 */}
          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
              1. General Refund Policy
            </Typography>
            <Typography variant="body1">
              Our courses and programs are digital products with immediate access
              to educational content upon enrollment. Due to the nature of digital
              content, all sales are generally final, and we do not offer refunds
              except in specific circumstances outlined below. We encourage you to
              carefully review course descriptions, requirements, and previews (if
              available) before enrolling to ensure the course meets your needs.
            </Typography>
          </Box>

          {/* Section 2 */}
          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
              2. Eligible Refund Circumstances
            </Typography>
            <List>
              <ListItem>
                <ListItemText primary="Technical Issues: If you experience persistent technical issues that we are unable to resolve within 7 days of enrollment." />
              </ListItem>
              <ListItem>
                <ListItemText primary="Duplicate Enrollment: If you accidentally enroll in the same course multiple times, you may request a refund for the duplicate purchase." />
              </ListItem>
              <ListItem>
                <ListItemText primary="Course Cancellation by Medby Academy: If we cancel a course before it begins, you will be eligible for a full refund." />
              </ListItem>
            </List>
          </Box>

          {/* Section 3 */}
          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
              3. Non-Refundable Circumstances
            </Typography>
            <List>
              <ListItem>
                <ListItemText primary="Change of mind or no longer wishing to participate after enrollment." />
              </ListItem>
              <ListItem>
                <ListItemText primary="Failure to meet course prerequisites or technical requirements." />
              </ListItem>
              <ListItem>
                <ListItemText primary="Accessing more than 10% of course materials." />
              </ListItem>
              <ListItem>
                <ListItemText primary="Refund requests made after the 7-day refund window." />
              </ListItem>
              <ListItem>
                <ListItemText primary="Violation of Terms & Conditions (e.g., sharing course access or materials)." />
              </ListItem>
            </List>
          </Box>

          {/* Section 4 */}
          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
              4. Refund Request Process
            </Typography>
            <Typography variant="body1" paragraph>
              To request a refund:
            </Typography>
            <List>
              <ListItem>
                <ListItemText primary="Contact us at admin@medbyacademy.com within 7 days of your enrollment or purchase date." />
              </ListItem>
              <ListItem>
                <ListItemText primary="Include your full name, email, course name, enrollment date, and explanation of your refund request." />
              </ListItem>
              <ListItem>
                <ListItemText primary="For technical issues, provide screenshots or other evidence." />
              </ListItem>
            </List>
            <Typography variant="body1">
              We will review your request and respond within 5–7 business days. If
              approved, refunds will be processed within 10 business days to the
              original payment method. Processing times may vary depending on your
              payment provider.
            </Typography>
          </Box>

          {/* Section 5-7 */}
          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
              5. Discounts and Promotions
            </Typography>
            <Typography variant="body1">
              Refunds (if approved) will be based on the amount you actually paid,
              not the full course price.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
              6. Course Transfers
            </Typography>
            <Typography variant="body1">
              Instead of a refund, we may offer the option to transfer your
              enrollment to another course of equal or lesser value, subject to
              availability and our discretion.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
              7. Changes to This Refund Policy
            </Typography>
            <Typography variant="body1">
              We reserve the right to update or modify this Refund Policy at any
              time. Changes will be posted on the Website with an updated "Last
              Updated" date.
            </Typography>
          </Box>

          {/* Contact */}
          <Box>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
              8. Contact Us
            </Typography>
            <Typography variant="body1">
              For questions or assistance with refund requests, please contact:
            </Typography>
            <Typography variant="body1" sx={{ mt: 1, fontWeight: "bold" }}>
              Email: support@medbyacademy.com
            </Typography>
          </Box>
        </Paper>
      </Container>
      <section><Footer /></section>
    </div>

  );
};

export default RefundPolicy;
